/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {AddressInput} from "./addressInput.zod";
import {CountryCode} from "./countryCode.zod";
import {PhoneNumberInput} from "./phoneNumberInput.zod";

export const PartyProfileInput = zod.object({
  address: AddressInput,
  country: CountryCode,
  phone: PhoneNumberInput,
  websiteUrl: zod.string().optional(),
});

export type PartyProfileInput = zod.input<typeof PartyProfileInput>;
export type PartyProfileInputOutput = zod.output<typeof PartyProfileInput>;
